module.exports = __webpack_public_path__ + "static/media/ourStoryGreen.65ea3682.svg";